const initialState = {
  all: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
  single: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
    post: {
      error: null,
      loading: false,
    },
    put: {
      error: null,
      loading: false,
    },
    setSystem: {
      error: null,
      loading: false,
    },
  },
  originalSystem: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
  products: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
    post: {
      error: null,
      loading: false,
    },
    put: {
      error: null,
      loading: false,
    },
  },
  share: {
    error: null,
    loading: false,
  },
  definition: {
    get: {
      error: null,
      loading: false,
    },
  },
};

export default function projects(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // CREATE PROJECTS
    case 'PROJECTS_CREATE_REQUEST':
      return {
        ...state,
        single: {
          ...state.single,
          post: {
            error: null,
            loading: true,
          },
        },
      };

    case 'PROJECTS_CREATE_SUCCESS':
      return {
        ...state,
        single: {
          ...state.single,
          post: {
            error: null,
            loading: false,
          },
        },
      };

    case 'PROJECTS_CREATE_FAILURE':
      return {
        ...state,
        single: {
          ...state.single,
          post: {
            error: payload,
            loading: false,
          },
        },
      };

    // GET PROJECT DEFINITION
    case 'PROJECT_DEFINITION_GET_REQUEST':
      return {
        ...state,
        definition: {
          error: null,
          loading: true,
        },
      };

    case 'PROJECT_DEFINITION_GET_SUCCESS':
      return {
        ...state,
        definition: {
          error: null,
          loading: false,
        },
      };

    case 'PROJECT_DEFINITION_GET_FAILURE':
      return {
        ...state,
        definition: {
          error: payload,
          loading: false,
        },
      };

    // SET PROJECT SYSTEM
    case 'PROJECTS_SET_SYSTEM_REQUEST':
      return {
        ...state,
        single: {
          ...state.single,
          setSystem: {
            error: null,
            loading: true,
          },
        },
      };
    case 'PROJECTS_SET_SYSTEM_FAILURE':
      return {
        ...state,
        single: {
          ...state.single,
          setSystem: {
            error: null,
            loading: false,
          },
        },
      };

    case 'PROJECTS_SET_SYSTEM_SUCCESS':
      return {
        ...state,
        single: {
          ...state.single,
          setSystem: {
            error: payload,
            loading: false,
          },
        },
      };

      // GET PROJECT
    case 'PROJECT_GET_REQUEST':
      return {
        ...state,
        single: {
          ...state.single,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'PROJECT_GET_SUCCESS':
      return {
        ...state,
        single: {
          ...state.single,
          data: {
            ...action.payload.data,
          },
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'PROJECT_GET_FAILURE':
      return {
        ...state,
        single: {
          ...state.single,
          get: {
            error: action.payload,
            loading: false,
          },
        },
      };

      // UPDATE PROJECT
    case 'PROJECT_UPDATE_REQUEST':
      return {
        ...state,
        single: {
          ...state.single,
          put: {
            error: null,
            loading: true,
          },
        },
      };

    case 'PROJECT_UPDATE_SUCCESS':
      return {
        ...state,
        single: {
          ...state.single,
          data: {
            ...action.payload.data,
            client: action.payload.included[0],
          },
          put: {
            error: null,
            loading: false,
          },
        },
      };

    case 'PROJECT_UPDATE_FAILURE':
      return {
        ...state,
        single: {
          ...state.single,
          put: {
            error: payload,
            loading: false,
          },
        },
      };

    // SHARE PROJECT
    case 'PROJECT_SHARE_REQUEST':
      return {
        ...state,
        share: {
          error: null,
          loading: true,
        },
      };

    case 'PROJECT_SHARE_SUCCESS':
      return {
        ...state,
        share: {
          error: null,
          loading: false,
        },
      };

    case 'PROJECT_SHARE_FAILURE':
      return {
        ...state,
        share: {
          error: payload,
          loading: false,
        },
      };

      // GET PRODUCTS OF PROJECT
    case 'PROJECT_GET_PRODUCTS_REQUEST':
      return {
        ...state,
        products: {
          ...state.products,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'PROJECT_GET_PRODUCTS_SUCCESS':
      return {
        ...state,
        products: {
          ...state.products,
          data: action.payload.data,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'PROJECT_GET_PRODUCTS_FAILURE':
      return {
        ...state,
        products: {
          ...state.products,
          get: {
            error: action.payload,
            loading: false,
          },
        },
      };

      // UPDATE PRODUCT OF PROJECT
    case 'PROJECT_UPDATE_PRODUCT_REQUEST':
      return {
        ...state,
        products: {
          ...state.products,
          put: {
            error: null,
            loading: true,
          },
        },
      };

    case 'PROJECT_UPDATE_PRODUCT_SUCCESS': {
      const products = state.products.data;
      const updatedProduct = payload.data;
      const index = products.findIndex(product => updatedProduct.id === product.id);

      if (index !== -1) {
        products[index] = updatedProduct;
      }

      return {
        ...state,
        products: {
          ...state.products,
          data: products,
          put: {
            error: null,
            loading: false,
          },
        },
      };
    }

    case 'PROJECT_UPDATE_PRODUCT_FAILURE':
      return {
        ...state,
        products: {
          ...state.products,
          put: {
            error: action.payload,
            loading: false,
          },
        },
      };

    case 'PROJECT_UPDATE_PRICE': {
      const { price } = payload;
      let { projectId } = payload;
      projectId = `${projectId}`;
      const { all } = state;
      const { data } = all;
      const resultData = [];
      // Search project by ID
      for (let i = 0, length = data.length; i < length; i += 1) {
        const project = data[i];
        const currentProjectId = `${project.id}`;
        let resultProject = project;
        if (projectId === currentProjectId) {
          resultProject = JSON.parse(JSON.stringify(project));
          resultProject.attributes.price = price; // Update the price! Thats why we're here.
        }
        resultData.push(resultProject);
      }

      return {
        ...state,
        all: {
          ...state.all,
          data: resultData,
        },
      };
    }
    case 'PROJECT_GET_ORIGINAL_SYSTEM_REQUEST': {
      return {
        ...state,
        originalSystem: {
          data: null,
          get: {
            error: null,
            loading: true,
          },
        },
      };
    }
    case 'PROJECT_GET_ORIGINAL_SYSTEM_SUCCESS': {
      return {
        ...state,
        originalSystem: {
          data: payload,
          get: {
            error: null,
            loading: false,
          },
        },
      };
    }
    case 'PROJECT_GET_ORIGINAL_SYSTEM_FAILURE': {
      return {
        ...state,
        originalSystem: {
          data: null,
          get: {
            error: payload,
            loading: false,
          },
        },
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/projects.js